module.exports = __webpack_public_path__ + "img/thc_1@2x.67f49bf2.png";